import { createContext, useContext, useEffect, useState, type ReactNode } from 'react';
import { api } from './api';

// anon = nincs belépve · authed = belépett a kóddal
type AuthState = 'loading' | 'anon' | 'authed';
interface AuthContextValue { state: AuthState; login: (code: string) => Promise<void>; logout: () => Promise<void>; refresh: () => Promise<void> }
const AuthContext = createContext<AuthContextValue | null>(null);

export function AuthProvider({ children }: { children: ReactNode }) {
  const [state, setState] = useState<AuthState>('loading');
  const refresh = async () => { try { const me = await api<{ authenticated: boolean }>('/api/auth/me'); setState(me.authenticated ? 'authed' : 'anon'); } catch { setState('anon'); } };
  const login = async (code: string) => { await api('/api/auth/login', { method: 'POST', body: JSON.stringify({ code }) }); await refresh(); };
  const logout = async () => { try { await api('/api/auth/logout', { method: 'POST' }); } finally { setState('anon'); } };
  useEffect(() => { void refresh(); }, []);
  return <AuthContext.Provider value={{ state, login, logout, refresh }}>{children}</AuthContext.Provider>;
}
export function useAuth(): AuthContextValue {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error('useAuth az AuthProvider-en kívül');
  return ctx;
}
